// BILLING-PLANS: a sent quote's PDF. Stripe gives a quote no link of its own, so the API fetches
// Stripe's rendering (`billing.quotes.pdf` for the client, `operator.billing.quotes.pdf` for the
// agency); it comes as a blob through the SDK, so the session cookie goes along.
import { useMutation } from "@tanstack/react-query";
import type { Api } from "../../api/client";

type Target =
  | { reader: "client"; companyId: string; quoteId: string }
  | { reader: "operator"; companyId: string; quoteId: string };

export function useQuotePdf(api: Api) {
  return useMutation({
    mutationFn: async (t: Target & { name: string }) => {
      const blob = (t.reader === "client"
        ? await api.client.call("billing.quotes.pdf", {
            params: { co: t.companyId, quote_id: t.quoteId },
          })
        : await api.client.call("operator.billing.quotes.pdf", {
            params: { company_id: t.companyId, quote_id: t.quoteId },
          })) as unknown as Blob;
      return { blob, name: t.name };
    },
    onSuccess: ({ blob, name }) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name.replace(/[^A-Za-z0-9._-]/g, "_")}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
  });
}
